import { NgModule } from '@angular/core';
// import {
//   MatButtonModule,
//   MatCheckboxModule,
//   MatIconModule,
//   MatMenuModule,
//   MatToolbarModule,
// MatFormFieldModule,
//   MatInputModule,
//   MatGridListModule,
//   MatProgressBar,
//   MatProgressBarModule,
//   MatDialogModule,
//   MatProgressSpinnerModule,
//   MatCardModule,
//   MatListModule,
//   MatTable,
//   MatTabsModule,
//   MatTableModule,
//   MatSortModule,
//   MatSidenavModule
// } from '@angular/material';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatStepperModule } from '@angular/material/stepper';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSortModule } from '@angular/material/sort';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatGridListResponsiveDirective } from './mat-grid-list-responsive.directive';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@NgModule({
  imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatMenuModule,
    // MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatGridListModule,
    // MatProgressBarModule,
    // MatDialogModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatListModule,
    // MatTableModule,
    // MatTabsModule,
    MatSortModule,
    MatTooltipModule,
    MatExpansionModule,
    FormsModule,
    MatSelectModule,
    MatRadioModule,
    ReactiveFormsModule,
    BrowserModule,
    MatSidenavModule,
    MatToolbarModule,
    MatPaginatorModule,
    MatStepperModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  declarations: [
    MatGridListResponsiveDirective
  ],
  exports: [
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatGridListModule,
    // MatProgressBarModule,
    // MatDialogModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatListModule,
    MatTableModule,
    // MatTabsModule,
    MatSortModule,
    BrowserModule,
    MatSidenavModule,
    MatToolbarModule,
    MatTooltipModule,
    MatExpansionModule,
    FormsModule,
    MatSelectModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatStepperModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatGridListResponsiveDirective,
    MatDatepickerModule,
    MatNativeDateModule
  ]
})
export class AngularMaterialModule { }
